import { create } from 'zustand';

import { TypeRegisterInputForm } from '~/types';

type TypeRegisterInputStore = {
  registerInfo: TypeRegisterInputForm;
  actions: {
    setRegisterInfo: (registerInfo: TypeRegisterInputForm) => void;
    resetRegisterInfo: () => void;
  };
};

const initialState = {
  registerInfo: {
    /** 아이디 */
    loginId: '',
    /** 비밀번호 */
    password: '',
    /** 비밀번호 확인 */
    checkPassword: '',
    /** 이름 */
    name: '',
    /** 휴대폰 번호 */
    phoneNumber: '',
    /** 인증번호 */
    verificationCode: '',
  },
};

/**
 * @description 작업자가 입력한 회원가입 정보를 가지고 있는 상태
 * @remarks 회원가입 완료되거나 페이지 이탈 시 초기화
 */
export const useRegisterInputStore = create<TypeRegisterInputStore>()((set) => ({
  ...initialState,
  actions: {
    setRegisterInfo: (registerInfo) => set({ registerInfo }),
    resetRegisterInfo: () => set({ registerInfo: initialState.registerInfo }),
  },
}));
